export default __webpack_public_path__ + "static/bg-min-99f4200f0b1d65d22f7f6838d26bff14.png";